module.exports = __webpack_public_path__ + "static/media/bg.575d1697.png";